import { render, staticRenderFns } from "./TranslatorPaymentTranslationsList.vue?vue&type=template&id=00e46280&"
import script from "./TranslatorPaymentTranslationsList.vue?vue&type=script&lang=js&"
export * from "./TranslatorPaymentTranslationsList.vue?vue&type=script&lang=js&"
import style0 from "./TranslatorPaymentTranslationsList.vue?vue&type=style&index=0&id=00e46280&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports